import React from "react";

// formBuilder labels are HTML typed in the staff screen (line breaks, bold, &nbsp; ...). They are turned into
// React elements from an allow-list instead of being injected, so a label can never carry script or links.
const INLINE = { b: "strong", strong: "strong", i: "em", em: "em", u: "u" };
const BLOCK = new Set(["div", "p", "li"]);

const toNodes = (node, key) => {
  if (node.nodeType === Node.TEXT_NODE) return node.textContent;
  if (node.nodeType !== Node.ELEMENT_NODE) return null;

  const tag = node.tagName.toLowerCase();
  if (tag === "br") return <br key={key} />;

  const children = Array.from(node.childNodes).map((child, i) => toNodes(child, `${key}-${i}`));
  if (INLINE[tag]) return React.createElement(INLINE[tag], { key }, children);
  if (BLOCK.has(tag)) {
    return (
      <React.Fragment key={key}>
        {children}
        <br />
      </React.Fragment>
    );
  }
  return <React.Fragment key={key}>{children}</React.Fragment>;
};

const parse = (html) => {
  if (typeof DOMParser === "undefined") return null;
  return new DOMParser().parseFromString(`<body>${html}</body>`, "text/html").body;
};

/** A formBuilder label as React elements (bold, italic, underline and line breaks kept). */
export const FormLabelText = ({ html }) => {
  const text = html == null ? "" : String(html);
  if (!/[<&]/.test(text)) return text;
  const body = parse(text);
  if (!body) return text;
  return <>{Array.from(body.childNodes).map((child, i) => toNodes(child, `n${i}`))}</>;
};

/** A formBuilder label as plain text (tags dropped, entities decoded, breaks kept as new lines). */
export const formLabelPlain = (html) => {
  const text = html == null ? "" : String(html);
  if (!/[<&]/.test(text)) return text;
  const body = parse(text.replace(/<br\s*\/?>/gi, "\n").replace(/<\/(div|p|li)>/gi, "\n"));
  return body ? body.textContent.trim() : text;
};

/** formBuilder's "class" of a paragraph: alert / well / panel draw a box in the staff screen too. */
export const isBoxedParagraph = (field) => /\b(alert|well|panel)\b/.test(field?.className || "");
